import { Box, Stack, Text } from '@chakra-ui/react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useEffect, useMemo, useState } from 'react';
import GeneralStaticWords from './GeneralStaticWords.js';
import _ from 'lodash';
import { getStaticWordData } from '../../services/StaticWords.js';
import MyTabsNested from '../../components/MyTabsNested.js';
import StaticWord from './StaticWord.js';
import { useDispatch } from 'react-redux';
import { setPreview } from '../../redux/actions/previewActions.js';

const EditStaticWordRecord = () => {
  const { id } = useParams();
  const [staticWordTitle, setStaticWordTitle] = useState();
  const location = useLocation();
  const dispatch = useDispatch()
  const navigate = useNavigate();

  const tabs = useMemo(() => [
    {
      id: "general", title: "General", Component: GeneralStaticWords, subTabs: [
        { id: "basic", title: "Basic", Component: StaticWord }
      ]
    }
  ], []);

  useEffect(() => {
    const getBasicData = async () => {
      try {
        if (id) {
          const result = await getStaticWordData(id);

          if (result) {
            // Service returns an array directly
            const data = Array.isArray(result) ? result[0] : result;
            setStaticWordTitle(data?.key || id);
          }
        }
      } catch (error) {
        console.error('Error fetching Static Word data:', error);
      }
    };

    getBasicData();
    dispatch(setPreview(false))
  }, [id, dispatch]);

  // Redirect to default tab if no tab is specified
  useEffect(() => {
    const pathParts = location.pathname.split('/');
    if (pathParts?.length === 3 && id) {
      // Redirect to the default tab/subTab
      navigate(`/static-words/${id}/${tabs[0].id}/${tabs?.[0].subTabs?.[0].id}`, { replace: true });
    }
  }, [location.pathname, id, navigate, tabs]);

  return (
    <Stack py="5px">
      <Box px="4" pb="4">
        <Text fontSize={"22px"} fontWeight={"600"}>{_.capitalize(staticWordTitle)}</Text>
      </Box>
      <MyTabsNested orientation="vertical" list={tabs} urlBasePath={"/static-words"} />
    </Stack>
  );
};

export default EditStaticWordRecord;
